module.exports = __webpack_public_path__ + "img/quienessomosf1.5711586f.webp";